import { TYPES } from '../reducer';

// This is an "Action Creator"
export const pushData = (payload) => ({
  type: TYPES.PUSH_DATA,
  payload
});